import { getFallbackMessage } from '../translationsCache';
export class FallbackErrorPolicy {
    constructor(onError) {
        this.onError = onError || console.warn;
    }
    handle(error, sourceString, localeCode, params) {
        this.onError('Translation error:', { error, sourceString, localeCode, params });
        return getFallbackMessage(sourceString, localeCode, params);
    }
}
//# sourceMappingURL=FallbackErrorPolicy.js.map